
import Export2 from "../../../assets/duotone/Export2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Export2Icon({ className, dataTestid = "Export2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Export2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
